import {
  primitiveColorVars
} from "./chunk-GHAMACRT.mjs";
import {
  semanticColorVars
} from "./chunk-EPIOL5DH.mjs";
import {
  effectVars
} from "./chunk-HBPD6Q3T.mjs";
import {
  createVariableMap
} from "./chunk-UA42UUKW.mjs";
import {
  nbcDark
} from "./chunk-ESBFBN5H.mjs";
import {
  nbcLight
} from "./chunk-HE2VQJGN.mjs";
import {
  sccDark
} from "./chunk-FMWUCKZI.mjs";
import {
  b2bDark
} from "./chunk-WFMGT4RS.mjs";
import {
  b2bLight
} from "./chunk-IWQV4SBZ.mjs";
import {
  hanghaeDark
} from "./chunk-GGUZ3K5X.mjs";
import {
  hanghaeLight
} from "./chunk-HSV3QRCK.mjs";
import {
  ipkDark
} from "./chunk-7TKMQKRQ.mjs";
import {
  ipkLight
} from "./chunk-KLJFGTT3.mjs";
import {
  createMetaTheme
} from "./chunk-QFOFFWMP.mjs";
import {
  createEffectTheme
} from "./chunk-WUUZD6PV.mjs";
import {
  createColorTheme
} from "./chunk-3YPHA6DP.mjs";
import {
  baseComponent
} from "./chunk-X4Q3EYYA.mjs";
import {
  primitiveColor
} from "./chunk-TUU3BKKT.mjs";
import {
  __spreadValues
} from "./chunk-LK3IYL3P.mjs";

// src/utils/mapColorTheme.ts
var mapColorTheme = (theme) => {
  switch (theme) {
    case "sccDark":
      return sccDark;
    case "nbcDark":
      return nbcDark;
    case "nbcLight":
      return nbcLight;
    case "hanghaeDark":
      return hanghaeDark;
    case "hanghaeLight":
      return hanghaeLight;
    case "ipkDark":
      return ipkDark;
    case "ipkLight":
      return ipkLight;
    case "sccLight":
      return sccLight;
    case "b2bDark":
      return b2bDark;
    case "b2bLight":
      return b2bLight;
    default:
      console.error(`Unsupported theme: ${theme}`);
      return sccLight;
  }
};

// src/tokens/vars/componentColorVars.ts
var componentColorVars = createVariableMap(
  baseComponent(__spreadValues(__spreadValues({}, createColorTheme(sccLight)), createEffectTheme(sccLight))),
  "stack-semantic"
);

// src/tokens/vars/vars.ts
var vars = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, primitiveColorVars), semanticColorVars), componentColorVars), effectVars);

// src/tokens/index.ts
var DEPRECATED_NEUTRAL_DAY = {
  gray90: "#1A1A1A",
  gray100: "#101010",
  white: "#FFFFFF"
};

// src/themes/sccLight.ts
var sccLight = createMetaTheme({
  colors: {
    brand: {
      strong: primitiveColor.pink[80],
      default: primitiveColor.pink[70],
      subtle: primitiveColor.pink[50],
      subtler: primitiveColor.pink[20],
      subtlest: primitiveColor.pink[5],
      faint: "#FA506926"
    }
  },
  effects: {},
  components: () => ({})
});

export {
  sccLight,
  mapColorTheme,
  componentColorVars,
  vars,
  DEPRECATED_NEUTRAL_DAY
};
